import { useEffect, useRef } from "react";

export function ConversionErrorBanner({
  message, attempt, onJump,
}: {
  message: string;
  attempt: number;
  onJump: () => void;
}) {
  const ref = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    ref.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [attempt]);

  return (
    <button
      ref={ref}
      type="button"
      onClick={onJump}
      className="mb-5 block w-full rounded-lg border border-destructive/30 bg-destructive/10 px-4 py-3 text-left text-sm text-destructive hover:bg-destructive/15"
    >
      {message}
    </button>
  );
}
